export default __webpack_public_path__ + "static/media/talk_image.7f551060.jpg";